import ctx from "../../plugins/axios";

/**
 * Update Specialties list.
 */
const updateSpecialties = async (payload) =>
  await ctx.post("/specialty", payload);

export default updateSpecialties;
